import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import Cookies from "js-cookie";

export const Mode_change_service = async (
  servicetablename,
  tablename,
  docId
) => {
  const select_company_uid = Cookies.get("select_company_uid");

  if (!select_company_uid) {
    return { success: false, error: "Contact service provider." };
  }

  if (!docId) {
    return { success: false, error: "Invalid service document." };
  }

  try {
    const serviceDocRef = doc(
      db,
      servicetablename,
      select_company_uid,
      tablename,
      docId
    );

    await setDoc(
      serviceDocRef,
      {
        mode_test: false,
        date_time_umode: serverTimestamp(),
      },
      { merge: true }
    );

    return { success: true };
  } catch (err) {
    return {
      success: false,
      error: err.message || "Unknown error",
    };
  }
};
